define([
  'redux',
  'es6!sumo/reducers/AppStore',
  'es6!sumo/list/reducers/index',
  'es6!launcher/reducers/settings',
  'es6!launcher/reducers/notifications',
  'es6!launcher/reducers/appState',

  'es6!launcher/reducers/messagecenter/automations',
  'es6!launcher/reducers/messagecenter/campaigns',
  'es6!launcher/reducers/messagecenter/settings',

  'es6!launcher/reducers/subscribers/imports',
  'es6!launcher/reducers/subscribers/campaigns',
  'es6!launcher/reducers/subscribers/settings',
  'es6!launcher/reducers/subscribers/subscribers',
  'es6!launcher/reducers/subscribers/lists',
  'es6!launcher/reducers/subscribers/segments',

  'es6!launcher/reducers/analytics/analytics',
  'es6!launcher/reducers/analytics/analyticsForm',
  'es6!launcher/reducers/analytics/analyticsPage',

  'es6!launcher/reducers/listbuilder/appState',
  'es6!launcher/reducers/listbuilder/popups',
  'es6!launcher/reducers/listbuilder/tests',
  'es6!launcher/reducers/listbuilder/stats',
  'es6!launcher/reducers/listbuilder/templates',
  'es6!launcher/reducers/listbuilder/discounts',
  'es6!launcher/reducers/listbuilder/settings',
  'es6!launcher/reducers/listbuilder/autoresponseemails',

  'es6!launcher/reducers/medias',

  'es6!launcher/reducers/displayrules',
  'es6!launcher/reducers/displayrulesets',

  'es6!launcher/reducers/shortcuts/shortcuts',

  'es6!launcher/reducers/share',
  'es6!launcher/reducers/imageSharer',

  'es6!launcher/reducers/ecommerce/ecommerce',
], (
  Redux,
  appstore,
  services,
  settings,
  notifications,
  appState,

  automations,
  campaigns,
  messageCenterSettings,

  imports,
  subscribersCampaigns,
  subscribersSettings,
  subscribers,
  subscriberLists,
  segments,

  analytics,
  analyticsForm,
  analyticsPage,

  listbuilderAppState,
  popups,
  tests,
  stats,
  templates,
  discounts,
  listbuilderSettings, // TODO: Combine with settings reducer from Message Center + Subscribers
  autoResponseEmails,

  medias,

  displayRules,
  displayRuleSets,

  shortcuts,

  share,
  imageSharer,

  ecommerce,
) => (
  Redux.combineReducers({
    appState,
    settings,
    services,
    notifications,
    appstore,

    automations,
    campaigns,
    messageCenterSettings,

    imports,
    subscribersCampaigns,
    subscribersSettings,
    subscribers,
    subscriberLists,
    segments,

    analytics,
    analyticsForm,
    analyticsPage,

    listbuilderAppState,
    popups,
    tests,
    stats,
    templates,
    listbuilderSettings,
    autoResponseEmails,
    discounts,

    medias,

    displayRules,
    displayRuleSets,

    shortcuts,

    share,
    imageSharer,

    ecommerce,
  })
));
